import { Directive } from '@angular/core';

/**
 * Marks the block that sits at the end of the header — the user menu, most often.
 *
 * It exists so the header can tell whether that zone is filled: the vertical rule in front of it is
 * drawn only when it is, and never left hanging at the edge of an empty bar.
 */
@Directive({
  selector: '[mibHeaderEnd]',
})
export class MibHeaderEndDirective {}
